var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStep3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 31,
    viewBox: "0 0 31 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15.5,
    cy: 15.5,
    r: 15.5,
    fill: "#D9D9D9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.766 20.7514C13.9376 20.7514 13.126 20.6339 12.3312 20.3988C11.5476 20.1525 10.8871 19.8167 10.3498 19.3913L11.2901 17.6953C11.7155 18.0424 12.2305 18.3222 12.835 18.5349C13.4395 18.7476 14.072 18.854 14.7324 18.854C15.516 18.854 16.1261 18.6972 16.5627 18.3838C16.9993 18.0591 17.2176 17.6226 17.2176 17.074C17.2176 16.5367 17.0161 16.1113 16.6131 15.7979C16.2101 15.4844 15.5608 15.3277 14.6653 15.3277H13.5906V13.8332L16.9489 9.83683L17.2344 10.6596H10.9207V8.82933H18.9303V10.2902L15.572 14.2866L14.4302 13.615H15.085C16.5291 13.615 17.6094 13.9396 18.3258 14.5889C19.0535 15.227 19.4173 16.0497 19.4173 17.0572C19.4173 17.7177 19.2494 18.3278 18.9135 18.8875C18.5777 19.4473 18.0628 19.9006 17.3687 20.2477C16.6859 20.5835 15.8183 20.7514 14.766 20.7514Z",
    fill: "#1B1A1F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStep3);
export default __webpack_public_path__ + "static/media/Step3.e9587f51042e090e53f55d5f0191ae13.svg";
export { ForwardRef as ReactComponent };